import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        { attrs: { dense: "" } },
        [
          _c(
            VCol,
            { attrs: { sm: "12", lg: "6" } },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-3" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold p-0" },
                        [_vm._v(_vm._s(_vm.texts.user) + " :")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-9" },
                    [
                      _c(VTextField, {
                        attrs: { dense: "", outlined: "", disabled: "" },
                        model: {
                          value: _vm.record.email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.record,
                              "email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "record.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { sm: "12", lg: "6" } },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-3" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold p-0" },
                        [_vm._v(_vm._s(_vm.texts.name) + " :")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-9" },
                    [
                      _c(VTextField, {
                        attrs: { dense: "", outlined: "", disabled: "" },
                        model: {
                          value: _vm.record.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.record,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "record.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VTabs,
        [
          _c(VTab, [_vm._v("Workspaces")]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: _vm.$t("my_tasks.modals.type_search"),
                  "append-outer-icon": "icon-search",
                },
                model: {
                  value: _vm.filterWorkspace,
                  callback: function ($$v) {
                    _vm.filterWorkspace = $$v
                  },
                  expression: "filterWorkspace",
                },
              }),
              _c(VDataTable, {
                staticClass: "table-inca",
                attrs: {
                  headers: _vm.fieldsWorkspace,
                  items: _vm.record.workspaces,
                  search: _vm.filterWorkspace,
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.capacity",
                    fn: function (row) {
                      return [_vm._v(_vm._s(row.item.capacity ? "Yes" : "No"))]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function (row) {
                      return [
                        _c(
                          VBtn,
                          {
                            staticClass: "btn-icon-inca",
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.onConfirmRequest(row.item)
                              },
                            },
                          },
                          [_c(VIcon, [_vm._v("icon-delete")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v("Datasets")]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: "Type to search",
                  "append-outer-icon": "icon-search",
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("label", [_vm._v(_vm._s(_vm.texts.search))])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.filterDataset,
                  callback: function ($$v) {
                    _vm.filterDataset = $$v
                  },
                  expression: "filterDataset",
                },
              }),
              _c(VDataTable, {
                attrs: {
                  headers: _vm.fieldsTableau,
                  items: _vm.record.datasets,
                  search: _vm.filterDataset,
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v(_vm._s(_vm.texts.report))]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: "Type to search",
                  "append-outer-icon": "icon-search",
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("label", [_vm._v(_vm._s(_vm.texts.search))])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.filterReport,
                  callback: function ($$v) {
                    _vm.filterReport = $$v
                  },
                  expression: "filterReport",
                },
              }),
              _c(VDataTable, {
                attrs: {
                  headers: _vm.fieldsTableau,
                  items: _vm.record.reports,
                  search: _vm.filterReport,
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v(_vm._s(_vm.texts.app))]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: "Type to search",
                  "append-outer-icon": "icon-search",
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("label", [_vm._v(_vm._s(_vm.texts.search))])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.filterApp,
                  callback: function ($$v) {
                    _vm.filterApp = $$v
                  },
                  expression: "filterApp",
                },
              }),
              _c(VDataTable, {
                attrs: {
                  headers: _vm.fieldsApps,
                  items: _vm.record.apps,
                  search: _vm.filterApp,
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-overlay", {
        attrs: { show: _vm.busy, "no-wrap": "", fixed: "" },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _vm.processing
                  ? _c(
                      "div",
                      [
                        _c("b-spinner", { attrs: { variant: "secondary" } }),
                        _c("p", [
                          _vm._v(
                            "The service account must have administrator permissions on the workspace."
                          ),
                        ]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        ref: "dialog",
                        staticClass: "text-center p-3",
                        attrs: {
                          tabindex: "-1",
                          role: "dialog",
                          "aria-modal": "false",
                          "aria-labelledby": "form-confirm-label",
                        },
                      },
                      [
                        _c("p", [
                          _c(
                            "strong",
                            { attrs: { id: "form-confirm-label" } },
                            [_vm._v(_vm._s(_vm.$t("frases.delete_workspace")))]
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  variant: "outline-danger",
                                  size: "sm",
                                },
                                on: { click: _vm.onCancelRequest },
                              },
                              [_vm._v(_vm._s(_vm.$t("botones.boton_cancelar")))]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-success",
                                  size: "sm",
                                },
                                on: { click: _vm.deletePermission },
                              },
                              [_vm._v("OK")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }